import { USER_ACCESS, USER_STATUS, UserStatus } from './types';

export const TABLE_HEADERS = [
  { content: 'User', field: 'email' },
  { content: 'Access', field: 'access' },
  { content: 'Actions', field: 'actions' },
];

export const ACCESS_OPTIONS = Object.values(USER_ACCESS);

export const USER_ACCESS_DEFAULT = 'Select Access';

export const ACCESS_OPTIONS_MAP: Record<USER_ACCESS | string, string> = {
  [USER_ACCESS.FULL]: 'Full',
  [USER_ACCESS.USER]: 'User',
  [USER_ACCESS.READ_LOG]: 'Read Log',
  [USER_ACCESS.LIMITED]: 'Limited',
  [USER_ACCESS_DEFAULT]: 'Select Access',
};

export const USER_STATUSES: Record<USER_STATUS, UserStatus> = {
  [USER_STATUS.INVITED]: { variant: 'pending', name: 'Invited' },
  [USER_STATUS.ACTIVE]: { variant: 'success', name: 'Active' },
};
